<template>
  <PreviewSheet radius="0">
    <OwnStack>
      <div class="email-header">
        <PreviewLogo class="email-header__logo" disable-palette size="xs" />
      </div>
      <PreviewHr />
      <PreviewSheet class="pa-7" background="secondary" radius="0">
        <span><!-- This is a gap between header and content --></span>
      </PreviewSheet>
    </OwnStack>
  </PreviewSheet>
</template>

<script>
import { PreviewLogo, PreviewHr, PreviewSheet } from '@/lib/builder'
import { OwnStack } from '@/ui'

export default {
  name: 'EmailHeader',
  components: { OwnStack, PreviewHr, PreviewLogo, PreviewSheet },
}
</script>

<style lang="scss" scoped>
.email-header {
  padding: 16px 40px;
}
</style>
